module.exports = __webpack_public_path__ + "img/013224b.jpg";